module.exports = __webpack_public_path__ + "img/application_bg2_m.c06c0852.jpg";